<template>
  <div class="card mt-2"  style="width:90%;">
    <div class="card-body">
      <div class="row">
        <div class="col-sm">
          <div class="input-group mb-1">
            <div class="input-group-prepend">
              <button @click="$emit('delete')" class="btn btn-danger" name="delfield"><font-awesome-icon icon="trash"/></button>
            </div>
            <input class="form-control" v-model="prop.name" type="text"/>
            <div class="input-group-append">
              <button @click="editSignal" name="edit" class="btn btn-info">...</button>
              <button @click="$emit('moveup')"   name="up-step"   class="btn btn-primary"><font-awesome-icon icon="arrow-up"/></button>
              <button @click="$emit('movedown')" name="down-step" class="btn btn-primary"><font-awesome-icon icon="arrow-down"/></button>
            </div>
          </div>
          <div class="col-sm">
            <div class="form-group">
              <input v-model="prop.group" type="checkbox" class="form-check-input"/>
              <label>gruppiert</label>
            </div>
          </div>
        </div>
      </div>
      <!-- if (dtype && ["csv","dbf","sql"].includes(dtype)) { var binds = {"csv":"field","sql":"colname","dbf":"colname"}; -->
      <div pclass="row" name="field-extend">
        <div class="col-sm">
          <div class="form-group">
            <!-- TODO make one name in basemap entry -->
            <div class="input-group" v-if="table.type=='csv'">
              <input type="text" v-model="prop.field" list="columnslist" placeholder="Spaltenname" class="form-control"/>
              <input type="text" v-model="prop.column" placeholder="Spaltenindex" class="form-control"/>
            </div>
            <input v-else-if="table.type=='dbf'" type="text" placeholder="Spaltenname" v-model="prop.colname" list="columnslist" class="form-control"/>
            <div class="input-group" v-if="table.type=='sql'">
              <input type="text" v-model="prop.colname" list="columnslist" placeholder="Spaltenname" class="form-control"/>
              <input type="text" v-model="prop.colidx" placeholder="Spaltenindex" class="form-control"/>
            </div>
            <input v-else-if="table.type=='json'" placeholder="JSON Accessor" type="text" v-model="prop.jsonfield" list="columnslist" class="form-control"/>
            <input v-else-if="table.type=='xml'" type="text" placeholder="XPath" v-model="prop.xpath" list="columnslist" class="form-control"/>
            <input v-else-if="table.type=='xlsx'" type="text" placeholder="Spalte" v-model="prop.column" list="columnslist" class="form-control"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DataTableField',
  props: ["prop","table"],
  mounted: function() {
    console.log(this.prop);
  },
  methods: {
    editSignal: function() {
      console.log('edit');
      console.log(this.prop);
      this.$emit('edit',this.prop);
    }
  }
}
</script>
